import React from "react";
import Seo from "../components/molecules/Seo";
import styled from "styled-components";
import Intro from "../components/molecules/Intro";
import {graphql} from 'gatsby';


export default function IndexPage(props) {

const home_images = props.data.prismicHome.data;

  return (
    <>
      <Seo title="Welcome" keywords={[`gatsby`, `application`, `react`]} />
      <Intro homeImages={home_images}/>
    </>
  );
};
      
export const pageQuery = graphql`
    query {
      prismicHome {
        data {
          link_1 {
            uid
          }
          link_2 {
            uid
          }
          link_3 {
            uid
          }
          link_4 {
            uid
          }
          link_5 {
            uid
          }
          link_6 {
            uid
          }
          link_7 {
            uid
          }
          client_1 {
            richText
          }
          client_2 {
            richText
          }
          client_3 {
            richText
          }
          client_4 {
            richText
          }
          client_5 {
            richText
          }
          client_6 {
            richText
          }
          client_7 {
            richText
          }
          image_1 {
            gatsbyImageData
            alt
            url
            dimensions {
                height
                width
                }
          }
          image_2 {
            gatsbyImageData
            alt
            url
            dimensions {
                height
                width
                }
          }
          image_3 {
            gatsbyImageData
            alt
            url
            dimensions {
                height
                width
                }
          }
          image_4 {
            gatsbyImageData
            alt
            url
            dimensions {
                height
                width
                }
          }
          image_5 {
            gatsbyImageData
            alt
            url
            dimensions {
                height
                width
                }
          }
          image_6 {
            gatsbyImageData
            alt
            url
            dimensions {
                height
                width
                }
          }
          image_7 {
            gatsbyImageData
            alt
            url
            dimensions {
                height
                width
                }
          }
        }
      }
    }
`;